import Axios from 'axios';

export const getGroupID = () => {
  return JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${process.env.REACT_APP_AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).profile.nickname;
};

export const getUserID = () => {
  return JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${process.env.REACT_APP_AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).profile.sub;
};

export const getDropdownSelectedValue = () => {
  return JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${process.env.REACT_APP_AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).profile.nickname;
};

export const AxiosAPI = setting => {
  const AUTHORITY_SERVER =
    process.env && process.env.REACT_APP_AUTHORITY_SERVER;
  const ACCESS_TOKEN = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).access_token;

  const { method, url, data, params } = setting;

  return Axios({
    method: method || '',
    url: url || '',
    data: data || null,
    params: params,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
    timeout: 100000000,
  });
};

export const AxiosPublicAPI = setting => {

  const { method, url, data, params } = setting;

  return Axios({
    method: method || '',
    url: url || '',
    data: data || null,
    params: params
  });
};

export const AxiosStripeAPI = setting => {
  const { method, url, data, params } = setting;
  return Axios({
    method: method || '',
    url: `https://api.stripe.com/${url}` || '',
    data: data || null,
    params: params,
    headers: {
      'Authorization': `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};


export const AxiosUserAPI = setting => {
  const { method, url, data, params } = setting;
  const AUTHORITY_SERVER =
  process.env && process.env.REACT_APP_AUTHORITY_SERVER;
  const ACCESS_TOKEN = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).access_token;
  return Axios({
    method: method || '',
    url: url || '',
    data: data || null,
    headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    params: params,
  });
};

export const setSelectedGroup = (selectedGroup) => {
  window.sessionStorage.setItem("groupId", JSON.stringify(selectedGroup));
};

export const getSelectedGroup = () => {
  const group = window.sessionStorage.getItem("groupId");
  return group ? JSON.parse(group) : undefined;
};

export const removeSelectedGroup = () => {
  const group = window.sessionStorage.removeItem("groupId");
  return group ? JSON.parse(group) : undefined;
};
